import { useQuery } from '@apollo/client';
import { GET_MY_SCOPE_TYPES } from '../gql/auth';
import { containsOneOf } from 'utils';

const useHasAnyScopeType = (expectedScopeType) => {
  const hasExpectedScopeType = containsOneOf(expectedScopeType);
  const { data, loading } = useQuery(GET_MY_SCOPE_TYPES, {
    // fetchPolicy: 'cache-and-network',
  });

  if (loading)
    return {
      loading: true,
      hasScopeType: false,
    };

  return {
    hasScopeType: hasExpectedScopeType(data.myScopeTypes),
    loading: false,
  };
};

export default useHasAnyScopeType;
